import { ICardResponse } from "./types";
import { cardsService } from "./cardsService";

export const getCard = async (cardId: string): Promise<ICardResponse> => {
  const { data } = await cardsService.get(`/${cardId}`);

  return data;
};
